import { useCallback, useEffect } from 'react'
import { useLocation } from '@reach/router'
import { useCheckout } from 'src/sdk/checkout/useCheckout'

import {
  buildAwinCustomData,
  buildFacebookCustomData,
} from './utils/buildCustomData'
import { getAwinParam } from './utils/getAwinParam'
import { getFacebookParams } from './utils/getFacebookParams'
import { findCustomApp } from './utils/findCustomApp'

export function SourceTracker() {
  const { search } = useLocation()
  const { isLoading, addCustomData, orderForm } = useCheckout()

  const dispatchAwinCustomData = useCallback(
    (params: URLSearchParams) => {
      const awcAwinParam = getAwinParam(params)

      addCustomData(buildAwinCustomData(awcAwinParam))
    },
    [addCustomData]
  )

  const dispatchFacebookCustomData = useCallback(() => {
    const { fbc, fbp } = getFacebookParams()

    addCustomData(buildFacebookCustomData({ fbc, fbp }))
  }, [addCustomData])

  useEffect(() => {
    const params = new URLSearchParams(search)
    const source = params.get('utm_source')

    if (isLoading) {
      return
    }

    const haveAwinSource = source === 'awin'
    const awinIsAttached = findCustomApp('track-awin', orderForm)

    if (haveAwinSource && !awinIsAttached) {
      dispatchAwinCustomData(params)
    }

    const { fbc, fbp } = getFacebookParams()
    const hasFacebookParams = !!fbc || !!fbp
    const facebookIsAttached = findCustomApp('track-facebook', orderForm)

    if (hasFacebookParams && !facebookIsAttached) {
      dispatchFacebookCustomData()
    }
  }, [
    search,
    dispatchAwinCustomData,
    dispatchFacebookCustomData,
    isLoading,
    orderForm,
  ])

  return null
}
